import React from 'react'
import PropTypes from 'prop-types'
import BlankModal from 'components/BlankModal'
import { View } from 'components/View'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import TextBody from 'components/TextBody'
import CircularProgress from 'components/CircularProgress'
import ButtonPrimary from 'components/ButtonPrimary'
import { useTheme } from 'modules/styles'
import { getFormScoreColorName } from 'modules/exercise-form-check/utils/get-form-score-color-name'

/**
 * Modal displaying detailed score information
 * @param {string} title - Score title
 * @param {number} score - Score value (0-100)
 * @param {string} summary - Detailed summary text
 * @param {string} emoji - Emoji icon
 * @param {Function} onClose - Close handler
 * @returns {Element}
 */
export default function ScoreDetailModal ({
  title,
  score,
  summary,
  emoji,
  onClose
}) {
  const theme = useTheme()
  const colorName = getFormScoreColorName(score)
  const color = theme.colors[colorName]

  return (
    <BlankModal onClose={onClose}>
      <View p={3} style={{ textAlign: 'center' }}>
        {/* Emoji */}
        <View mb={2} style={{ fontSize: '3em' }}>
          {emoji}
        </View>

        {/* Title */}
        <View mb={3}>
          <TextTitleCompressedHeavy>
            {title}
          </TextTitleCompressedHeavy>
        </View>

        {/* Circular Progress */}
        <View mb={3} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <CircularProgress
            percentage={score}
            size={120}
            strokeWidth={8}
            color={color}
          />
        </View>

        {/* Summary */}
        <View mb={3}>
          <TextBody style={{ color: theme.colors.paragraph }}>
            {summary}
          </TextBody>
        </View>

        {/* Close Button - Full Width */}
        <View>
          <ButtonPrimary onClick={onClose} style={{ width: '100%' }}>
            Close
          </ButtonPrimary>
        </View>
      </View>
    </BlankModal>
  )
}

ScoreDetailModal.propTypes = {
  title: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired,
  summary: PropTypes.string.isRequired,
  emoji: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
}
